import { useDispatch, useSelector } from 'react-redux'
import { Analytics } from '../../../reducers/analyticsReducer'
import { Setting } from '../../../reducers/settingReducer'
import ReviewTimeStackedChart from '.'
import messageInteraction from '../utils/messageInteraction'
import { useState, useEffect } from 'react'
import { useAxiosWithHeader } from '../../../utils'
import { URLBACK_VELOFRAME } from '../../../assets/urls'
import { createStandardQuery } from '../utils/query'

export default function ReviewTimeStackedContainer({pullRequestRelations = 'events,pull_request_reviews,pull_request_reviews.creator,review_requests,creator', marginTime}) {
  const analytics = useSelector(Analytics.selectors.getAnalytics)
  const organizationId = analytics.id
  const axios = useAxiosWithHeader('analytics')
  const setting = useSelector(Setting.selectors.getSetting)
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(false)

  useEffect(() => {
    setLoading(true)
    async function getCycleTime({ axios, setting, organizationId, dispatch }) {
      try {
        if (!setting.loadingInitialQuery) {
          const res = await axios.get(
            `${URLBACK_VELOFRAME}api/reviews/averageReviewTimePerPullRequest?pullRequestRelations=${pullRequestRelations}&${createStandardQuery(
              { setting, organizationId },
            )}`,
          )

          dispatch(Analytics.actions.setData({ reviewTime: res.data }))
        }
      } catch (e) {
        messageInteraction({
          content: 'Error in get average review time. Please refresh or contact support.',
          type: 'error',
        })
        setError(true)
        console.log('Error get average review time: ', e)
      }
      setLoading(false)
    }
    getCycleTime({ axios, setting, organizationId, dispatch })
  }, [
    setting.startDate,
    setting.endDate,
    setting.selectedRepositories,
    setting.selectedTeams,
  ])

  return (
    <ReviewTimeStackedChart loading={loading} error={error} marginTime={marginTime} />
  )
}
